// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "../Utilities/ErrorUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./ConfirmType.bs.js";
import * as CountryStateDataRefs$OrcaPaymentPage from "../CountryStateDataRefs.bs.js";

var defaultCardDetails = {
  scheme: undefined,
  last4Digits: "",
  expiryMonth: "",
  expiryYear: "",
  cardToken: "",
  cardHolderName: undefined,
  nickname: "",
  isClickToPayCard: false,
  cardBin: ""
};

var defaultAddressDetails = {
  line1: undefined,
  line2: undefined,
  line3: undefined,
  city: undefined,
  state: undefined,
  country: undefined,
  zip: undefined
};

var defaultDisplayBillingDetails = {
  address: defaultAddressDetails
};

var defaultCustomerMethods_bank = {
  mask: ""
};

var defaultCustomerMethods = {
  paymentToken: "",
  customerId: "",
  paymentMethod: "",
  paymentMethodId: "",
  paymentMethodIssuer: undefined,
  card: defaultCardDetails,
  paymentMethodType: undefined,
  defaultPaymentMethodSet: false,
  requiresCvv: true,
  lastUsedAt: "",
  bank: defaultCustomerMethods_bank,
  recurringEnabled: false,
  billing: defaultDisplayBillingDetails
};

var defaultGroupingBehavior = {
  displayInSeparateScreen: true,
  groupByPaymentMethods: false
};

var defaultSavedMethodCustomization_hiddenPaymentMethods = [];

var defaultSavedMethodCustomization = {
  groupingBehavior: defaultGroupingBehavior,
  maxItems: 4,
  hideCardExpiry: false,
  defaultCollapsed: true,
  hiddenPaymentMethods: defaultSavedMethodCustomization_hiddenPaymentMethods
};

var defaultLayout = {
  defaultCollapsed: false,
  radios: false,
  spacedAccordionItems: false,
  maxAccordionItems: 4,
  type: "Tabs",
  savedMethodCustomization: defaultSavedMethodCustomization,
  paymentMethodsArrangementForTabs: "Default",
  displayOneClickPaymentMethodsOnTop: true,
  showCheckedIconForSelection: false,
  separatorText: undefined,
  cvcIcon: "Default",
  cardBrandIcon: "Standard"
};

var defaultAddress = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  country: "",
  postal_code: ""
};

var defaultBillingDetails = {
  name: "",
  email: "",
  phone: "",
  address: defaultAddress
};

var defaultBusiness = {
  name: ""
};

var defaultDefaultValues = {
  billingDetails: defaultBillingDetails
};

var defaultshowAddress = {
  line1: "Auto",
  line2: "Auto",
  city: "Auto",
  state: "Auto",
  country: "Auto",
  postal_code: "Auto"
};

var defaultNeverShowAddress = {
  line1: "Never",
  line2: "Never",
  city: "Never",
  state: "Never",
  country: "Never",
  postal_code: "Never"
};

var defaultBilling_address = {
  TAG: "JSONObject",
  _0: defaultshowAddress
};

var defaultBilling = {
  name: "Auto",
  email: "Auto",
  phone: "Auto",
  address: defaultBilling_address
};

var defaultNeverBilling_address = {
  TAG: "JSONObject",
  _0: defaultNeverShowAddress
};

var defaultNeverBilling = {
  name: "Never",
  email: "Never",
  phone: "Never",
  address: defaultNeverBilling_address
};

var defaultTerms = {
  auBecsDebit: "Auto",
  bancontact: "Auto",
  card: "Auto",
  ideal: "Auto",
  sepaDebit: "Auto",
  sofort: "Auto",
  usBankAccount: "Auto"
};

var defaultFields = {
  billingDetails: {
    TAG: "JSONObject",
    _0: defaultBilling
  }
};

var defaultStyle = {
  type_: [
    {
      TAG: "ApplePay",
      _0: "Default"
    },
    {
      TAG: "GooglePay",
      _0: "Default"
    },
    {
      TAG: "Paypal",
      _0: "Paypal"
    },
    {
      TAG: "SamsungPay",
      _0: "Buy"
    }
  ],
  theme: "Light",
  height: [
    {
      TAG: "ApplePay",
      _0: 48
    },
    {
      TAG: "GooglePay",
      _0: 48
    },
    {
      TAG: "Paypal",
      _0: 48
    },
    {
      TAG: "Klarna",
      _0: 48
    },
    {
      TAG: "SamsungPay",
      _0: 48
    }
  ],
  buttonRadius: 2
};

var defaultWallets_applePay = {
  TAG: "ApplePayConfigString",
  _0: "Auto"
};

var defaultWallets_googlePay = {
  TAG: "GooglePayConfigString",
  _0: "Auto"
};

var defaultWallets_payPal = {
  TAG: "PaypalConfigString",
  _0: "Auto"
};

var defaultWallets = {
  walletReturnUrl: "",
  applePay: defaultWallets_applePay,
  googlePay: defaultWallets_googlePay,
  payPal: defaultWallets_payPal,
  klarna: "Auto",
  paze: "Auto",
  samsungPay: "Auto",
  style: defaultStyle
};

var defaultBillingAddress = {
  isUseBillingAddress: false,
  usePrefilledValues: "Auto"
};

var defaultSdkHandleConfirmPayment = {
  handleConfirm: false,
  confirmParams: ConfirmType$OrcaPaymentPage.defaultConfirm
};

var defaultSdkHandleSavePayment = {
  handleSave: false,
  confirmParams: ConfirmType$OrcaPaymentPage.defaultConfirm
};

var defaultOptions_layout = {
  TAG: "ObjectLayout",
  _0: defaultLayout
};

var defaultOptions_customMethodNames = [];

var defaultOptions_paymentMethodsConfig = [];

var defaultOptions = {
  defaultValues: defaultDefaultValues,
  layout: defaultOptions_layout,
  business: defaultBusiness,
  customerPaymentMethods: "LoadingSavedCards",
  displaySavedPaymentMethodsCheckbox: true,
  displaySavedPaymentMethods: true,
  savedPaymentMethodsCheckboxCheckedByDefault: false,
  fields: defaultFields,
  readOnly: false,
  terms: defaultTerms,
  wallets: defaultWallets,
  customMethodNames: defaultOptions_customMethodNames,
  branding: "Auto",
  payButtonStyle: defaultStyle,
  billingAddress: defaultBillingAddress,
  sdkHandleConfirmPayment: defaultSdkHandleConfirmPayment,
  sdkHandleSavePayment: defaultSdkHandleSavePayment,
  hideExpiredPaymentMethods: false,
  displayDefaultSavedPaymentIcon: true,
  hideCardNicknameField: false,
  displayBillingDetails: false,
  customMessageForCardTerms: "",
  showShortSurchargeMessage: false,
  paymentMethodsConfig: defaultOptions_paymentMethodsConfig,
  alwaysSendCustomerAcceptance: false,
  redirectionInfo: "ShowRedirectionInfo"
};

function getMessageDisplayMode(str, key) {
  switch (str) {
    case "custom_message" :
        return "CustomMessage";
    case "default_sdk_message" :
        return "DefaultSdkMessage";
    case "hidden" :
        return "Hidden";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "default_sdk_message",
            "custom_message",
            "hidden"
          ], key);
      return "DefaultSdkMessage";
  }
}

var defaultPaymentMethodMessage = {
  value: undefined,
  displayMode: "DefaultSdkMessage"
};

function getPaymentMethodMessage(dict, logger, context) {
  var messageDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "message");
  if (Object.entries(messageDict).length <= 0) {
    return defaultPaymentMethodMessage;
  }
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "value",
        "displayMode"
      ], messageDict, context + ".message");
  var value = Utils$OrcaPaymentPage.getOptionString(messageDict, "value");
  var displayMode = Core__Option.isSome(messageDict["displayMode"]) ? getMessageDisplayMode(Utils$OrcaPaymentPage.getWarningString(messageDict, "displayMode", "default_sdk_message", logger), context + ".message.displayMode") : (
      value !== undefined ? "CustomMessage" : "DefaultSdkMessage"
    );
  return {
          value: value,
          displayMode: displayMode
        };
}

function getPaymentMethodTypeConfig(json, logger, paymentMethod) {
  var context = "options.paymentMethodsConfig." + paymentMethod;
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "paymentMethodType",
        "message"
      ], json, context);
  return {
          paymentMethodType: Utils$OrcaPaymentPage.getWarningString(json, "paymentMethodType", "", logger),
          message: getPaymentMethodMessage(json, logger, context)
        };
}

function getPaymentMethodConfig(json, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "paymentMethod",
        "message",
        "paymentMethodTypes"
      ], json, "options.paymentMethodsConfig");
  var paymentMethod = Utils$OrcaPaymentPage.getWarningString(json, "paymentMethod", "", logger);
  return {
          paymentMethod: paymentMethod,
          message: getPaymentMethodMessage(json, logger, "options.paymentMethodsConfig." + paymentMethod),
          paymentMethodTypes: Utils$OrcaPaymentPage.getArrayOfObjectsFromDict(json, "paymentMethodTypes").map(function (pmTypeJson) {
                return getPaymentMethodTypeConfig(pmTypeJson, logger, paymentMethod);
              })
        };
}

function getPaymentMethodsConfig(dict, str, logger) {
  return Utils$OrcaPaymentPage.getArrayOfObjectsFromDict(dict, str).map(function (json) {
              return getPaymentMethodConfig(json, logger);
            });
}

function getLayout(str) {
  switch (str) {
    case "accordion" :
        return "Accordion";
    case "tabs" :
        return "Tabs";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "tabs",
            "accordion"
          ], "options.layout");
      return "Tabs";
  }
}

function getPaymentMethodsArrangementForTabs(str) {
  switch (str) {
    case "default" :
        return "Default";
    case "grid" :
        return "Grid";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "grid",
            "default"
          ], "options.paymentMethodsArrangementForTabs");
      return "Default";
  }
}

function getCvcIconStyle(str) {
  switch (str) {
    case "" :
    case "default" :
        return "Default";
    case "hidden" :
        return "Hidden";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "hidden",
            "default"
          ], "options.layout.cvcIcon");
      return "Default";
  }
}

function getCardBrandIconStyle(str) {
  switch (str) {
    case "animated" :
        return "Animated";
    case "hidden" :
        return "Hidden";
    case "hideGeneric" :
        return "HideGeneric";
    case "" :
    case "standard" :
        return "Standard";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "standard",
            "hidden",
            "animated",
            "hideGeneric"
          ], "options.layout.cardBrandIcon");
      return "Standard";
  }
}

function getAddress(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    var countryData = CountryStateDataRefs$OrcaPaymentPage.countryDataRef.contents;
                    var countryNames = Utils$OrcaPaymentPage.getCountryNames(countryData);
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "line1",
                          "line2",
                          "city",
                          "state",
                          "country",
                          "postal_code"
                        ], json, "options.defaultValues.billingDetails.address");
                    var country = Utils$OrcaPaymentPage.getWarningString(json, "country", "", logger);
                    if (country !== "") {
                      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(country, countryNames, "options.defaultValues.billingDetails.address.country");
                    }
                    return {
                            line1: Utils$OrcaPaymentPage.getWarningString(json, "line1", "", logger),
                            line2: Utils$OrcaPaymentPage.getWarningString(json, "line2", "", logger),
                            city: Utils$OrcaPaymentPage.getWarningString(json, "city", "", logger),
                            state: Utils$OrcaPaymentPage.getWarningString(json, "state", "", logger),
                            country: country,
                            postal_code: Utils$OrcaPaymentPage.getWarningString(json, "postal_code", "", logger)
                          };
                  })), defaultAddress);
}

function getBillingDetails(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "name",
                          "email",
                          "phone",
                          "address"
                        ], json, "options.defaultValues.billingDetails");
                    return {
                            name: Utils$OrcaPaymentPage.getWarningString(json, "name", "", logger),
                            email: Utils$OrcaPaymentPage.getWarningString(json, "email", "", logger),
                            phone: Utils$OrcaPaymentPage.getWarningString(json, "phone", "", logger),
                            address: getAddress(json, "address", logger)
                          };
                  })), defaultBillingDetails);
}

function getDefaultValues(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning(["billingDetails"], json, "options.defaultValues");
                    return {
                            billingDetails: getBillingDetails(json, "billingDetails", logger)
                          };
                  })), defaultDefaultValues);
}

function getBusiness(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning(["name"], json, "options.business");
                    return {
                            name: Utils$OrcaPaymentPage.getWarningString(json, "name", "", logger)
                          };
                  })), defaultBusiness);
}

function getShowType(str, key) {
  switch (str) {
    case "auto" :
        return "Auto";
    case "never" :
        return "Never";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "auto",
            "never"
          ], key);
      return "Auto";
  }
}

function getApplePayType(str) {
  switch (str) {
    case "add-money" :
    case "addmoney" :
        return {
                TAG: "ApplePay",
                _0: "AddMoney"
              };
    case "book" :
        return {
                TAG: "ApplePay",
                _0: "Book"
              };
    case "buy" :
        return {
                TAG: "ApplePay",
                _0: "Buy"
              };
    case "check-out" :
    case "checkout" :
        return {
                TAG: "ApplePay",
                _0: "Checkout"
              };
    case "contribute" :
        return {
                TAG: "ApplePay",
                _0: "Contribute"
              };
    case "default" :
        return {
                TAG: "ApplePay",
                _0: "Default"
              };
    case "donate" :
        return {
                TAG: "ApplePay",
                _0: "Donate"
              };
    case "order" :
        return {
                TAG: "ApplePay",
                _0: "Order"
              };
    case "reload" :
        return {
                TAG: "ApplePay",
                _0: "Reload"
              };
    case "rent" :
        return {
                TAG: "ApplePay",
                _0: "Rent"
              };
    case "set-up" :
    case "setup" :
        return {
                TAG: "ApplePay",
                _0: "SetUp"
              };
    case "subscribe" :
        return {
                TAG: "ApplePay",
                _0: "Subscribe"
              };
    case "support" :
        return {
                TAG: "ApplePay",
                _0: "Support"
              };
    case "tip" :
        return {
                TAG: "ApplePay",
                _0: "Tip"
              };
    case "top-up" :
    case "topup" :
        return {
                TAG: "ApplePay",
                _0: "TopUp"
              };
    default:
      return {
              TAG: "ApplePay",
              _0: "Plain"
            };
  }
}

function getGooglePayType(str) {
  switch (str) {
    case "book" :
        return {
                TAG: "GooglePay",
                _0: "Book"
              };
    case "buy" :
    case "buynow" :
        return {
                TAG: "GooglePay",
                _0: "Buy"
              };
    case "check-out" :
    case "checkout" :
        return {
                TAG: "GooglePay",
                _0: "Checkout"
              };
    case "donate" :
        return {
                TAG: "GooglePay",
                _0: "Donate"
              };
    case "order" :
        return {
                TAG: "GooglePay",
                _0: "Order"
              };
    case "pay" :
        return {
                TAG: "GooglePay",
                _0: "Pay"
              };
    case "subscribe" :
        return {
                TAG: "GooglePay",
                _0: "Subscribe"
              };
    default:
      return {
              TAG: "GooglePay",
              _0: "Default"
            };
  }
}

function getSamsungPayType(str) {
  return {
          TAG: "SamsungPay",
          _0: "Buy"
        };
}

function getPayPalType(str) {
  switch (str) {
    case "buy" :
    case "buynow" :
        return {
                TAG: "Paypal",
                _0: "Buynow"
              };
    case "check-out" :
    case "checkout" :
        return {
                TAG: "Paypal",
                _0: "Checkout"
              };
    case "installment" :
        return {
                TAG: "Paypal",
                _0: "Installment"
              };
    case "pay" :
        return {
                TAG: "Paypal",
                _0: "Pay"
              };
    default:
      return {
              TAG: "Paypal",
              _0: "Paypal"
            };
  }
}

function getTypeArray(str) {
  var goodVals = [
    "checkout",
    "pay",
    "buy",
    "installment",
    "pay",
    "default",
    "book",
    "donate",
    "order",
    "addmoney",
    "topup",
    "rent",
    "subscribe",
    "reload",
    "support",
    "tip",
    "contribute"
  ];
  if (!goodVals.includes(str)) {
    ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, goodVals, "options.wallets.style.type");
  }
  return [
          getApplePayType(str),
          getGooglePayType(str),
          getPayPalType(str),
          {
            TAG: "SamsungPay",
            _0: "Buy"
          }
        ];
}

function getShowDetails(billingDetails) {
  if (billingDetails.TAG === "JSONString") {
    if (getShowType(billingDetails._0, "fields.billingDetails") === "Never") {
      return defaultNeverBilling;
    } else {
      return defaultBilling;
    }
  } else {
    return billingDetails._0;
  }
}

function getShowAddressDetails(billingDetails) {
  if (billingDetails.TAG === "JSONString") {
    if (getShowType(billingDetails._0, "fields.billingDetails") === "Never") {
      return defaultNeverShowAddress;
    } else {
      return defaultshowAddress;
    }
  }
  var str = billingDetails._0.address;
  if (str.TAG === "JSONString") {
    if (getShowType(str._0, "fields.billingDetails.address") === "Never") {
      return defaultNeverShowAddress;
    } else {
      return defaultshowAddress;
    }
  } else {
    return str._0;
  }
}

function getShowTerms(str, key) {
  switch (str) {
    case "always" :
        return "Always";
    case "auto" :
        return "Auto";
    case "never" :
        return "Never";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "auto",
            "always",
            "never"
          ], key);
      return "Auto";
  }
}

function getShowAddress(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            line1: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "line1", "auto", logger), "options.fields.address.line1"),
                            line2: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "line2", "auto", logger), "options.fields.address.line2"),
                            city: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "city", "auto", logger), "options.fields.address.city"),
                            state: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "state", "auto", logger), "options.fields.address.state"),
                            country: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "country", "auto", logger), "options.fields.address.country"),
                            postal_code: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "postal_code", "auto", logger), "options.fields.name.postal_code")
                          };
                  })), defaultshowAddress);
}

function getDeatils(val, logger) {
  var str = Core__JSON.Classify.classify(val);
  if (typeof str !== "object") {
    return {
            TAG: "JSONString",
            _0: ""
          };
  }
  switch (str.TAG) {
    case "String" :
        return {
                TAG: "JSONString",
                _0: str._0
              };
    case "Object" :
        var json = str._0;
        return {
                TAG: "JSONObject",
                _0: {
                  name: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "name", "auto", logger), "options.fields.name"),
                  email: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "email", "auto", logger), "options.fields.email"),
                  phone: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "phone", "auto", logger), "options.fields.phone"),
                  address: {
                    TAG: "JSONObject",
                    _0: getShowAddress(json, "address", logger)
                  }
                }
              };
    default:
      return {
              TAG: "JSONString",
              _0: ""
            };
  }
}

function getBilling(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(dict[str], (function (json) {
                    return getDeatils(json, logger);
                  })), defaultFields.billingDetails);
}

function getFields(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            billingDetails: getBilling(json, "billingDetails", logger)
                          };
                  })), defaultFields);
}

function getGroupingBehaviorFromString(str) {
  switch (str) {
    case "default" :
        return defaultGroupingBehavior;
    case "groupByPaymentMethods" :
        return {
                displayInSeparateScreen: false,
                groupByPaymentMethods: true
              };
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "groupByPaymentMethods",
            "default"
          ], "options.layout.savedMethodCustomization.groupingBehavior");
      return defaultGroupingBehavior;
  }
}

function getGroupingBehaviorFromObject(json, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "displayInSeparateScreen",
        "groupByPaymentMethods"
      ], json, "options.layout.savedMethodCustomization.groupingBehavior");
  return {
          displayInSeparateScreen: Utils$OrcaPaymentPage.getBoolWithWarning(json, "displayInSeparateScreen", true, logger),
          groupByPaymentMethods: Utils$OrcaPaymentPage.getBoolWithWarning(json, "groupByPaymentMethods", false, logger)
        };
}

function getGroupingBehavior(dict, logger) {
  return Core__Option.getOr(Core__Option.map(dict["groupingBehavior"], (function (val) {
                    var str = Core__JSON.Classify.classify(val);
                    if (typeof str !== "object") {
                      return defaultGroupingBehavior;
                    }
                    switch (str.TAG) {
                      case "String" :
                          return getGroupingBehaviorFromString(str._0);
                      case "Object" :
                          return getGroupingBehaviorFromObject(str._0, logger);
                      default:
                        return defaultGroupingBehavior;
                    }
                  })), defaultGroupingBehavior);
}

function getMaxItems(dict, key, $$default, logger) {
  var parsedMaxItems = Utils$OrcaPaymentPage.getNumberWithWarning(dict, key, logger, $$default);
  if (parsedMaxItems > 0) {
    return parsedMaxItems;
  } else {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(parsedMaxItems, "options.layout.savedMethodCustomization.maxItems", "[>0] - maxItems must be a positive number. Value set to default (4)", logger);
    return $$default;
  }
}

function getSavedMethodCustomization(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "groupingBehavior",
                          "maxItems",
                          "hideCardExpiry",
                          "defaultCollapsed",
                          "hiddenPaymentMethods"
                        ], json, "options.layout.savedMethodCustomization");
                    return {
                            groupingBehavior: getGroupingBehavior(json, logger),
                            maxItems: getMaxItems(json, "maxItems", 4, logger),
                            hideCardExpiry: Utils$OrcaPaymentPage.getBool(json, "hideCardExpiry", false),
                            defaultCollapsed: Utils$OrcaPaymentPage.getBoolWithWarning(json, "defaultCollapsed", true, logger),
                            hiddenPaymentMethods: Utils$OrcaPaymentPage.getStrArray(json, "hiddenPaymentMethods")
                          };
                  })), defaultSavedMethodCustomization);
}

function getLayoutValues(val, logger) {
  var str = Core__JSON.Classify.classify(val);
  if (typeof str !== "object") {
    return {
            TAG: "StringLayout",
            _0: "Tabs"
          };
  }
  switch (str.TAG) {
    case "String" :
        return {
                TAG: "StringLayout",
                _0: getLayout(str._0)
              };
    case "Object" :
        var json = str._0;
        var layoutType = Utils$OrcaPaymentPage.getWarningString(json, "type", "tabs", logger);
        var paymentMethodsArrangementForTabsType = Utils$OrcaPaymentPage.getWarningString(json, "paymentMethodsArrangementForTabs", "default", logger);
        return {
                TAG: "ObjectLayout",
                _0: (ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                        "defaultCollapsed",
                        "radios",
                        "spacedAccordionItems",
                        "type",
                        "maxAccordionItems",
                        "savedMethodCustomization",
                        "paymentMethodsArrangementForTabs",
                        "displayOneClickPaymentMethodsOnTop",
                        "showCheckedIconForSelection",
                        "separatorText",
                        "cvcIcon",
                        "cardBrandIcon"
                      ], json, "options.layout"), {
                    defaultCollapsed: Utils$OrcaPaymentPage.getBoolWithWarning(json, "defaultCollapsed", false, logger),
                    radios: Utils$OrcaPaymentPage.getBoolWithWarning(json, "radios", false, logger),
                    spacedAccordionItems: Utils$OrcaPaymentPage.getBoolWithWarning(json, "spacedAccordionItems", false, logger),
                    maxAccordionItems: Utils$OrcaPaymentPage.getNumberWithWarning(json, "maxAccordionItems", logger, 4),
                    type: getLayout(layoutType),
                    savedMethodCustomization: getSavedMethodCustomization(json, "savedMethodCustomization", logger),
                    paymentMethodsArrangementForTabs: getPaymentMethodsArrangementForTabs(paymentMethodsArrangementForTabsType),
                    displayOneClickPaymentMethodsOnTop: Utils$OrcaPaymentPage.getBoolWithWarning(json, "displayOneClickPaymentMethodsOnTop", true, logger),
                    showCheckedIconForSelection: Utils$OrcaPaymentPage.getBoolWithWarning(json, "showCheckedIconForSelection", false, logger),
                    separatorText: Utils$OrcaPaymentPage.getOptionString(json, "separatorText"),
                    cvcIcon: getCvcIconStyle(Utils$OrcaPaymentPage.getWarningString(json, "cvcIcon", "", logger)),
                    cardBrandIcon: getCardBrandIconStyle(Utils$OrcaPaymentPage.getWarningString(json, "cardBrandIcon", "standard", logger))
                  })
              };
    default:
      return {
              TAG: "StringLayout",
              _0: "Tabs"
            };
  }
}

function getTerms(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "auBecsDebit",
                          "bancontact",
                          "card",
                          "ideal",
                          "sepaDebit",
                          "sofort",
                          "usBankAccount"
                        ], json, "options.terms");
                    return {
                            auBecsDebit: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "auBecsDebit", "auto", logger), "options.terms.auBecsDebit"),
                            bancontact: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "bancontact", "auto", logger), "options.terms.bancontact"),
                            card: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "card", "auto", logger), "options.terms.card"),
                            ideal: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "ideal", "auto", logger), "options.terms.ideal"),
                            sepaDebit: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "sepaDebit", "auto", logger), "options.terms.sepaDebit"),
                            sofort: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "sofort", "auto", logger), "options.terms.sofort"),
                            usBankAccount: getShowTerms(Utils$OrcaPaymentPage.getWarningString(json, "usBankAccount", "auto", logger), "options.terms.usBankAccount")
                          };
                  })), defaultTerms);
}

function getApplePayHeight(val, logger) {
  if (val >= 45) {
    return {
            TAG: "ApplePay",
            _0: val
          };
  } else {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[h>=45] - ApplePay. Value set to min", logger);
    return {
            TAG: "ApplePay",
            _0: 48
          };
  }
}

function getGooglePayHeight(val, logger) {
  if (val >= 45) {
    return {
            TAG: "GooglePay",
            _0: val
          };
  } else {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[h>=45] - GooglePay. Value set to min", logger);
    return {
            TAG: "GooglePay",
            _0: 48
          };
  }
}

function getSamsungPayHeight(val, logger) {
  if (val >= 45) {
    return {
            TAG: "SamsungPay",
            _0: val
          };
  } else {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[h>=45] - SamsungPay. Value set to min", logger);
    return {
            TAG: "SamsungPay",
            _0: 48
          };
  }
}

function getPaypalHeight(val, logger) {
  if (val < 25) {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[25-55] - Paypal. Value set to min", logger);
    return {
            TAG: "Paypal",
            _0: 25
          };
  } else if (val > 55) {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[25-55] - Paypal. Value set to max", logger);
    return {
            TAG: "Paypal",
            _0: 55
          };
  } else {
    return {
            TAG: "Paypal",
            _0: val
          };
  }
}

function getKlarnaHeight(val, logger) {
  if (val < 40) {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[40-60] - Klarna. Value set to min", logger);
    return {
            TAG: "Klarna",
            _0: 40
          };
  } else if (val > 60) {
    ErrorUtils$OrcaPaymentPage.valueOutRangeWarning(val, "options.style.height", "[40-60] - Paypal. Value set to max", logger);
    return {
            TAG: "Klarna",
            _0: 60
          };
  } else {
    return {
            TAG: "Klarna",
            _0: val
          };
  }
}

function getTheme(str) {
  switch (str) {
    case "dark" :
        return "Dark";
    case "light" :
        return "Light";
    case "outline" :
        return "Outline";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(str, [
            "outline",
            "light",
            "dark"
          ], "options.styles.theme");
      return "Dark";
  }
}

function getHeightArray(val, logger) {
  return [
          getApplePayHeight(val, logger),
          getGooglePayHeight(val, logger),
          getPaypalHeight(val, logger),
          getKlarnaHeight(val, logger),
          getSamsungPayHeight(val, logger)
        ];
}

function getStyle(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "type",
                          "theme",
                          "height"
                        ], json, "options.wallets.style");
                    return {
                            type_: getTypeArray(Utils$OrcaPaymentPage.getWarningString(json, "type", "", logger)),
                            theme: getTheme(Utils$OrcaPaymentPage.getWarningString(json, "theme", "", logger)),
                            height: getHeightArray(Utils$OrcaPaymentPage.getNumberWithWarning(json, "height", logger, 48), logger),
                            buttonRadius: Utils$OrcaPaymentPage.getNumberWithWarning(json, "buttonRadius", logger, 2)
                          };
                  })), defaultStyle);
}

function getGooglePayWalletConfig(json, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "display",
        "buttonColor",
        "buttonType",
        "height",
        "buttonRadius",
        "buttonBorderType"
      ], json, "options.wallets.googlePay");
  var v = Core__Option.flatMap(json["buttonColor"], Core__JSON.Decode.string);
  var tmp;
  if (v !== undefined) {
    switch (v) {
      case "black" :
          tmp = "GPayBlack";
          break;
      case "default" :
          tmp = "GPayDefault";
          break;
      case "white" :
          tmp = "GPayWhite";
          break;
      default:
        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(v, [
              "black",
              "white",
              "default"
            ], "options.wallets.googlePay.buttonColor");
        tmp = "GPayDefault";
    }
  } else {
    tmp = "GPayDefault";
  }
  var v$1 = Core__Option.flatMap(json["buttonBorderType"], Core__JSON.Decode.string);
  var tmp$1;
  if (v$1 !== undefined) {
    switch (v$1) {
      case "default_border" :
          tmp$1 = "GPayDefaultBorder";
          break;
      case "no_border" :
          tmp$1 = "GPayNoBorder";
          break;
      default:
        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(v$1, [
              "no_border",
              "default_border"
            ], "options.wallets.googlePay.buttonBorderType");
        tmp$1 = "GPayDefaultBorder";
    }
  } else {
    tmp$1 = "GPayDefaultBorder";
  }
  return {
          display: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "display", "auto", logger), "options.wallets.googlePay.display"),
          buttonColor: tmp,
          buttonType: Core__Option.map(Core__Option.map(Core__Option.flatMap(json["buttonType"], Core__JSON.Decode.string), getGooglePayType), (function (t) {
                  if (t.TAG === "GooglePay") {
                    return t._0;
                  } else {
                    return "Default";
                  }
                })),
          height: Core__Option.map(Core__Option.flatMap(json["height"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                })),
          buttonRadius: Core__Option.map(Core__Option.flatMap(json["buttonRadius"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                })),
          buttonBorderType: tmp$1
        };
}

function getPaypalWalletConfig(json, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "display",
        "color",
        "label",
        "height",
        "shape",
        "borderRadius"
      ], json, "options.wallets.payPal");
  var v = Core__Option.flatMap(json["color"], Core__JSON.Decode.string);
  var tmp;
  if (v !== undefined) {
    switch (v) {
      case "black" :
          tmp = "PaypalBlack";
          break;
      case "blue" :
          tmp = "PaypalBlue";
          break;
      case "gold" :
          tmp = "PaypalGold";
          break;
      case "silver" :
          tmp = "PaypalSilver";
          break;
      case "white" :
          tmp = "PaypalWhite";
          break;
      default:
        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(v, [
              "gold",
              "blue",
              "silver",
              "black",
              "white"
            ], "options.wallets.payPal.color");
        tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var v$1 = Core__Option.flatMap(json["shape"], Core__JSON.Decode.string);
  var tmp$1;
  if (v$1 !== undefined) {
    switch (v$1) {
      case "pill" :
          tmp$1 = "PaypalPill";
          break;
      case "rect" :
          tmp$1 = "PaypalRect";
          break;
      case "sharp" :
          tmp$1 = "PaypalSharp";
          break;
      default:
        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(v$1, [
              "rect",
              "pill",
              "sharp"
            ], "options.wallets.payPal.shape");
        tmp$1 = "PaypalRect";
    }
  } else {
    tmp$1 = "PaypalRect";
  }
  return {
          display: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "display", "auto", logger), "options.wallets.payPal.display"),
          color: tmp,
          label: Core__Option.getOr(Core__Option.map(Core__Option.map(Core__Option.flatMap(json["label"], Core__JSON.Decode.string), getPayPalType), (function (t) {
                      if (t.TAG === "Paypal") {
                        return t._0;
                      }
                      
                    })), undefined),
          height: Core__Option.map(Core__Option.flatMap(json["height"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                })),
          shape: tmp$1,
          borderRadius: Core__Option.map(Core__Option.flatMap(json["borderRadius"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                }))
        };
}

function getGooglePayWalletField(dict, key, logger) {
  var json = dict[key];
  if (json === undefined) {
    return {
            TAG: "GooglePayConfigString",
            _0: "Auto"
          };
  }
  var str = Core__JSON.Decode.string(json);
  if (str !== undefined) {
    return {
            TAG: "GooglePayConfigString",
            _0: getShowType(str, "options.wallets." + key)
          };
  }
  var obj = Core__JSON.Decode.object(json);
  if (obj !== undefined) {
    return {
            TAG: "GooglePayConfigObj",
            _0: getGooglePayWalletConfig(obj, logger)
          };
  } else {
    return {
            TAG: "GooglePayConfigString",
            _0: "Auto"
          };
  }
}

function getPaypalWalletField(dict, key, logger) {
  var json = dict[key];
  if (json === undefined) {
    return {
            TAG: "PaypalConfigString",
            _0: "Auto"
          };
  }
  var str = Core__JSON.Decode.string(json);
  if (str !== undefined) {
    return {
            TAG: "PaypalConfigString",
            _0: getShowType(str, "options.wallets." + key)
          };
  }
  var obj = Core__JSON.Decode.object(json);
  if (obj !== undefined) {
    return {
            TAG: "PaypalConfigObj",
            _0: getPaypalWalletConfig(obj, logger)
          };
  } else {
    return {
            TAG: "PaypalConfigString",
            _0: "Auto"
          };
  }
}

function getApplePayWalletConfig(json, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
        "display",
        "buttonStyle",
        "buttonType",
        "height",
        "buttonRadius"
      ], json, "options.wallets.applePay");
  var v = Core__Option.flatMap(json["buttonStyle"], Core__JSON.Decode.string);
  var tmp;
  if (v !== undefined) {
    switch (v) {
      case "black" :
          tmp = "ApplePayBlack";
          break;
      case "white" :
          tmp = "ApplePayWhite";
          break;
      case "white-outline" :
          tmp = "ApplePayWhiteOutline";
          break;
      default:
        ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(v, [
              "black",
              "white",
              "white-outline"
            ], "options.wallets.applePay.buttonStyle");
        tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  return {
          display: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "display", "auto", logger), "options.wallets.applePay.display"),
          buttonStyle: tmp,
          buttonType: Core__Option.getOr(Core__Option.map(Core__Option.map(Core__Option.flatMap(json["buttonType"], Core__JSON.Decode.string), getApplePayType), (function (t) {
                      if (t.TAG === "ApplePay") {
                        return t._0;
                      } else {
                        return "Plain";
                      }
                    })), "Plain"),
          height: Core__Option.map(Core__Option.flatMap(json["height"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                })),
          buttonRadius: Core__Option.map(Core__Option.flatMap(json["buttonRadius"], Core__JSON.Decode.$$float), (function (prim) {
                  return prim | 0;
                }))
        };
}

function getApplePayWalletField(dict, key, logger) {
  var json = dict[key];
  if (json === undefined) {
    return {
            TAG: "ApplePayConfigString",
            _0: "Auto"
          };
  }
  var str = Core__JSON.Decode.string(json);
  if (str !== undefined) {
    return {
            TAG: "ApplePayConfigString",
            _0: getShowType(str, "options.wallets." + key)
          };
  }
  var obj = Core__JSON.Decode.object(json);
  if (obj !== undefined) {
    return {
            TAG: "ApplePayConfigObj",
            _0: getApplePayWalletConfig(obj, logger)
          };
  } else {
    return {
            TAG: "ApplePayConfigString",
            _0: "Auto"
          };
  }
}

function getWallets(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "applePay",
                          "googlePay",
                          "style",
                          "walletReturnUrl",
                          "payPal",
                          "klarna",
                          "samsungPay",
                          "paze"
                        ], json, "options.wallets");
                    return {
                            walletReturnUrl: Utils$OrcaPaymentPage.getRequiredString(json, "walletReturnUrl", "", logger),
                            applePay: getApplePayWalletField(json, "applePay", logger),
                            googlePay: getGooglePayWalletField(json, "googlePay", logger),
                            payPal: getPaypalWalletField(json, "payPal", logger),
                            klarna: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "klarna", "auto", logger), "options.wallets.klarna"),
                            paze: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "paze", "auto", logger), "options.wallets.paze"),
                            samsungPay: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "samsungPay", "auto", logger), "options.wallets.samsungPay"),
                            style: getStyle(json, "style", logger)
                          };
                  })), defaultWallets);
}

function getRedirectionInfo(dict, str, logger) {
  var value = Utils$OrcaPaymentPage.getWarningString(dict, str, "show", logger);
  switch (value) {
    case "hidden" :
        return "HideRedirectionInfo";
    case "show" :
        return "ShowRedirectionInfo";
    default:
      ErrorUtils$OrcaPaymentPage.unknownPropValueWarning(value, [
            "show",
            "hidden"
          ], "options.redirectionInfo");
      return "ShowRedirectionInfo";
  }
}

function getLayout$1(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(dict[str], (function (json) {
                    return getLayoutValues(json, logger);
                  })), {
              TAG: "ObjectLayout",
              _0: defaultLayout
            });
}

function getCardDetails(dict, str) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            scheme: Utils$OrcaPaymentPage.getString(json, "scheme", ""),
                            last4Digits: Utils$OrcaPaymentPage.getString(json, "last4_digits", ""),
                            expiryMonth: Utils$OrcaPaymentPage.getString(json, "expiry_month", ""),
                            expiryYear: Utils$OrcaPaymentPage.getString(json, "expiry_year", ""),
                            cardToken: Utils$OrcaPaymentPage.getString(json, "card_token", ""),
                            cardHolderName: Utils$OrcaPaymentPage.getOptionString(json, "card_holder_name"),
                            nickname: Utils$OrcaPaymentPage.getString(json, "nick_name", ""),
                            isClickToPayCard: false,
                            cardBin: Utils$OrcaPaymentPage.getString(json, "card_isin", "")
                          };
                  })), defaultCardDetails);
}

function getAddressDetails(dict, str) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            line1: Utils$OrcaPaymentPage.getString(json, "line1", ""),
                            line2: Utils$OrcaPaymentPage.getString(json, "line2", ""),
                            line3: Utils$OrcaPaymentPage.getString(json, "line3", ""),
                            city: Utils$OrcaPaymentPage.getString(json, "city", ""),
                            state: Utils$OrcaPaymentPage.getString(json, "state", ""),
                            country: Utils$OrcaPaymentPage.getString(json, "country", ""),
                            zip: Utils$OrcaPaymentPage.getString(json, "zip", "")
                          };
                  })), defaultAddressDetails);
}

function getBillingAddressPaymentMethod(dict, str) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    return {
                            address: getAddressDetails(json, "address")
                          };
                  })), defaultDisplayBillingDetails);
}

function getPaymentMethodType(dict) {
  return Core__Option.flatMap(dict["payment_method_type"], Core__JSON.Decode.string);
}

function getBank(dict) {
  return {
          mask: Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "bank"), "mask", "")
        };
}

function itemToCustomerObjMapper(customerDict) {
  var customerArr = Utils$OrcaPaymentPage.getArray(customerDict, "customer_payment_methods");
  var isGuestCustomer = Utils$OrcaPaymentPage.getBool(customerDict, "is_guest_customer", false);
  var customerPaymentMethods = Belt_Array.keepMap(customerArr, Core__JSON.Decode.object).map(function (dict) {
        return {
                paymentToken: Utils$OrcaPaymentPage.getString(dict, "payment_token", ""),
                customerId: Utils$OrcaPaymentPage.getString(dict, "customer_id", ""),
                paymentMethod: Utils$OrcaPaymentPage.getString(dict, "payment_method", ""),
                paymentMethodId: Utils$OrcaPaymentPage.getString(dict, "payment_method_id", ""),
                paymentMethodIssuer: Utils$OrcaPaymentPage.getOptionString(dict, "payment_method_issuer"),
                card: getCardDetails(dict, "card"),
                paymentMethodType: getPaymentMethodType(dict),
                defaultPaymentMethodSet: Utils$OrcaPaymentPage.getBool(dict, "default_payment_method_set", false),
                requiresCvv: Utils$OrcaPaymentPage.getBool(dict, "requires_cvv", true),
                lastUsedAt: Utils$OrcaPaymentPage.getString(dict, "last_used_at", ""),
                bank: getBank(dict),
                recurringEnabled: Utils$OrcaPaymentPage.getBool(dict, "recurring_enabled", false),
                billing: getBillingAddressPaymentMethod(dict, "billing")
              };
      });
  return [
          customerPaymentMethods,
          isGuestCustomer
        ];
}

function createCustomerObjArr(dict, key) {
  var customerDict = Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), {});
  var match = itemToCustomerObjMapper(customerDict);
  return {
          TAG: "LoadedSavedCards",
          _0: match[0],
          _1: match[1]
        };
}

function getCustomerMethods(dict, str) {
  var customerArr = Core__Option.getOr(Core__Option.flatMap(dict[str], Core__JSON.Decode.array), []);
  if (customerArr.length === 0) {
    return "LoadingSavedCards";
  }
  var customerPaymentMethods = Belt_Array.keepMap(customerArr, Core__JSON.Decode.object).map(function (json) {
        return {
                paymentToken: Utils$OrcaPaymentPage.getString(json, "payment_token", ""),
                customerId: Utils$OrcaPaymentPage.getString(json, "customer_id", ""),
                paymentMethod: Utils$OrcaPaymentPage.getString(json, "payment_method", ""),
                paymentMethodId: Utils$OrcaPaymentPage.getString(json, "payment_method_id", ""),
                paymentMethodIssuer: Utils$OrcaPaymentPage.getString(json, "payment_method_issuer", ""),
                card: getCardDetails(json, "card"),
                paymentMethodType: getPaymentMethodType(dict),
                defaultPaymentMethodSet: Utils$OrcaPaymentPage.getBool(dict, "default_payment_method_set", false),
                requiresCvv: Utils$OrcaPaymentPage.getBool(dict, "requires_cvv", true),
                lastUsedAt: Utils$OrcaPaymentPage.getString(dict, "last_used_at", ""),
                bank: getBank(dict),
                recurringEnabled: Utils$OrcaPaymentPage.getBool(dict, "recurring_enabled", false),
                billing: getBillingAddressPaymentMethod(json, "billing")
              };
      });
  return {
          TAG: "LoadedSavedCards",
          _0: customerPaymentMethods,
          _1: false
        };
}

function getCustomMethodNames(dict, str) {
  return Belt_Array.keepMap(Core__Option.getOr(Core__Option.flatMap(dict[str], Core__JSON.Decode.array), []), Core__JSON.Decode.object).map(function (json) {
              return {
                      paymentMethodName: Utils$OrcaPaymentPage.getString(json, "paymentMethodName", ""),
                      aliasName: Utils$OrcaPaymentPage.getString(json, "aliasName", "")
                    };
            });
}

function getBillingAddress(dict, str, logger) {
  return Core__Option.getOr(Core__Option.map(Core__Option.flatMap(dict[str], Core__JSON.Decode.object), (function (json) {
                    ErrorUtils$OrcaPaymentPage.unknownKeysWarning([
                          "isUseBillingAddress",
                          "usePrefilledValues"
                        ], json, "options.billingAddress");
                    return {
                            isUseBillingAddress: Utils$OrcaPaymentPage.getBoolWithWarning(json, "isUseBillingAddress", false, logger),
                            usePrefilledValues: getShowType(Utils$OrcaPaymentPage.getWarningString(json, "usePrefilledValues", "auto", logger), "options.billingAddress.usePrefilledValues")
                          };
                  })), defaultBillingAddress);
}

function getConfirmParams(dict) {
  return {
          return_url: Utils$OrcaPaymentPage.getString(dict, "return_url", ""),
          publishableKey: Utils$OrcaPaymentPage.getString(dict, "publishableKey", ""),
          redirect: Utils$OrcaPaymentPage.getString(dict, "redirect", "if_required")
        };
}

function getSdkHandleConfirmPaymentProps(dict) {
  return {
          handleConfirm: Utils$OrcaPaymentPage.getBool(dict, "handleConfirm", false),
          buttonText: Utils$OrcaPaymentPage.getOptionString(dict, "buttonText"),
          confirmParams: getConfirmParams(Utils$OrcaPaymentPage.getDictFromDict(dict, "confirmParams"))
        };
}

function getSdkHandleSavePaymentProps(dict) {
  return {
          handleSave: Utils$OrcaPaymentPage.getBool(dict, "handleSave", false),
          buttonText: Utils$OrcaPaymentPage.getOptionString(dict, "buttonText"),
          confirmParams: getConfirmParams(Utils$OrcaPaymentPage.getDictFromDict(dict, "confirmParams"))
        };
}

var allowedPaymentElementOptions = [
  "defaultValues",
  "business",
  "layout",
  "paymentMethodOrder",
  "customerPaymentMethods",
  "fields",
  "readOnly",
  "terms",
  "wallets",
  "displaySavedPaymentMethodsCheckbox",
  "displaySavedPaymentMethods",
  "savedPaymentMethodsCheckboxCheckedByDefault",
  "sdkHandleOneClickConfirmPayment",
  "sdkHandleConfirmPayment",
  "sdkHandleSavePayment",
  "paymentMethodsHeaderText",
  "savedPaymentMethodsHeaderText",
  "hideExpiredPaymentMethods",
  "branding",
  "displayDefaultSavedPaymentIcon",
  "hideCardNicknameField",
  "displayBillingDetails",
  "customMessageForCardTerms",
  "showShortSurchargeMessage",
  "paymentMethodsConfig",
  "alwaysSendCustomerAcceptance",
  "redirectionInfo"
];

var fieldsToExcludeFromMasking = [
  "layout",
  "wallets",
  "paymentMethodsConfig",
  "terms"
];

var overrideFieldsToExcludeFromMasking = [
  "wallets.walletReturnUrl",
  "paymentMethodsConfig.paymentMethodTypes.message.value"
];

function normalizePath(path) {
  return path.replace(/\[(\d+)\]/g, "");
}

function isPathStartsWithPattern(normalizedPath, normalizedPattern) {
  if (normalizedPath === normalizedPattern) {
    return true;
  } else {
    return normalizedPath.startsWith(normalizedPattern + ".");
  }
}

function shouldMaskField(path) {
  var normalizedPath = normalizePath(path);
  var isOverridden = overrideFieldsToExcludeFromMasking.includes(normalizedPath);
  var isExcluded = fieldsToExcludeFromMasking.some(function (pattern) {
        return isPathStartsWithPattern(normalizedPath, normalizePath(pattern));
      });
  if (isOverridden) {
    return true;
  } else {
    return !isExcluded;
  }
}

function sanitizePaymentElementOptions(dict) {
  return Utils$OrcaPaymentPage.getDictFromJson((function (__x) {
                  return Utils$OrcaPaymentPage.maskStringValuesInJson(__x, "", 0, shouldMaskField);
                })(dict));
}

function sanitizePreloadSdkParms(dict) {
  return Utils$OrcaPaymentPage.getDictFromJson((function (__x) {
                  return Utils$OrcaPaymentPage.maskStringValuesInJson(__x, "", 0, (function (param) {
                                return true;
                              }));
                })(dict));
}

function itemToObjMapper(dict, logger) {
  ErrorUtils$OrcaPaymentPage.unknownKeysWarning(allowedPaymentElementOptions, dict, "options");
  logger.setLogInfo(JSON.stringify(sanitizePaymentElementOptions(dict)), "PAYMENT_ELEMENT_OPTIONS", undefined, undefined, "INFO", undefined, undefined);
  return {
          defaultValues: getDefaultValues(dict, "defaultValues", logger),
          layout: getLayout$1(dict, "layout", logger),
          business: getBusiness(dict, "business", logger),
          customerPaymentMethods: getCustomerMethods(dict, "customerPaymentMethods"),
          paymentMethodOrder: Utils$OrcaPaymentPage.getOptionalStrArray(dict, "paymentMethodOrder"),
          displaySavedPaymentMethodsCheckbox: Utils$OrcaPaymentPage.getBoolWithWarning(dict, "displaySavedPaymentMethodsCheckbox", true, logger),
          displaySavedPaymentMethods: Utils$OrcaPaymentPage.getBoolWithWarning(dict, "displaySavedPaymentMethods", true, logger),
          savedPaymentMethodsCheckboxCheckedByDefault: Utils$OrcaPaymentPage.getBoolWithWarning(dict, "savedPaymentMethodsCheckboxCheckedByDefault", false, logger),
          fields: getFields(dict, "fields", logger),
          readOnly: Utils$OrcaPaymentPage.getBoolWithWarning(dict, "readOnly", false, logger),
          terms: getTerms(dict, "terms", logger),
          wallets: getWallets(dict, "wallets", logger),
          customMethodNames: getCustomMethodNames(dict, "customMethodNames"),
          branding: getShowType(Utils$OrcaPaymentPage.getWarningString(dict, "branding", "auto", logger), "options.branding"),
          payButtonStyle: getStyle(dict, "payButtonStyle", logger),
          billingAddress: getBillingAddress(dict, "billingAddress", logger),
          sdkHandleConfirmPayment: getSdkHandleConfirmPaymentProps(Utils$OrcaPaymentPage.getDictFromDict(dict, "sdkHandleConfirmPayment")),
          sdkHandleSavePayment: getSdkHandleSavePaymentProps(Utils$OrcaPaymentPage.getDictFromDict(dict, "sdkHandleSavePayment")),
          paymentMethodsHeaderText: Utils$OrcaPaymentPage.getOptionString(dict, "paymentMethodsHeaderText"),
          savedPaymentMethodsHeaderText: Utils$OrcaPaymentPage.getOptionString(dict, "savedPaymentMethodsHeaderText"),
          hideExpiredPaymentMethods: Utils$OrcaPaymentPage.getBool(dict, "hideExpiredPaymentMethods", false),
          displayDefaultSavedPaymentIcon: Utils$OrcaPaymentPage.getBool(dict, "displayDefaultSavedPaymentIcon", true),
          hideCardNicknameField: Utils$OrcaPaymentPage.getBool(dict, "hideCardNicknameField", false),
          displayBillingDetails: Utils$OrcaPaymentPage.getBool(dict, "displayBillingDetails", false),
          customMessageForCardTerms: Utils$OrcaPaymentPage.getString(dict, "customMessageForCardTerms", ""),
          showShortSurchargeMessage: Utils$OrcaPaymentPage.getBool(dict, "showShortSurchargeMessage", false),
          paymentMethodsConfig: getPaymentMethodsConfig(dict, "paymentMethodsConfig", logger),
          alwaysSendCustomerAcceptance: Utils$OrcaPaymentPage.getBool(dict, "alwaysSendCustomerAcceptance", false),
          redirectionInfo: getRedirectionInfo(dict, "redirectionInfo", logger)
        };
}

function getIsStoredPaymentMethodHasName(savedMethod) {
  return Core__Option.getOr(savedMethod.card.cardHolderName, "").length > 0;
}

function itemToPayerDetailsObjectMapper(dict) {
  return {
          email: Core__Option.flatMap(dict["email_address"], Core__JSON.Decode.string),
          phone: Core__Option.flatMap(Core__Option.flatMap(Core__Option.flatMap(Core__Option.flatMap(Core__Option.flatMap(dict["phone"], Core__JSON.Decode.object), (function (__x) {
                              return __x["phone_number"];
                            })), Core__JSON.Decode.object), (function (__x) {
                      return __x["national_number"];
                    })), Core__JSON.Decode.string)
        };
}

function convertClickToPayCardToCustomerMethod(clickToPayCard, clickToPayProvider) {
  var cardScheme;
  switch (clickToPayProvider) {
    case "VISA" :
        cardScheme = Core__Option.getOr(clickToPayCard.paymentCardDescriptor, "").toLowerCase() === "mastercard" ? "Mastercard" : "Visa";
        break;
    case "MASTERCARD" :
        var other = clickToPayCard.paymentCardDescriptor.toLowerCase();
        var tmp;
        switch (other) {
          case "amex" :
              tmp = "AmericanExpress";
              break;
          case "discover" :
              tmp = "Discover";
              break;
          case "mastercard" :
              tmp = "Mastercard";
              break;
          case "visa" :
              tmp = "Visa";
              break;
          default:
            tmp = other.charAt(0).toUpperCase().concat(other.slice(1).toLowerCase());
        }
        cardScheme = tmp;
        break;
    case "NONE" :
        cardScheme = undefined;
        break;
    
  }
  return {
          paymentToken: clickToPayCard.srcDigitalCardId,
          customerId: "",
          paymentMethod: "card",
          paymentMethodId: clickToPayCard.srcDigitalCardId,
          paymentMethodIssuer: undefined,
          card: {
            scheme: cardScheme,
            last4Digits: clickToPayCard.panLastFour,
            expiryMonth: clickToPayCard.panExpirationMonth,
            expiryYear: clickToPayCard.panExpirationYear,
            cardToken: clickToPayCard.srcDigitalCardId,
            cardHolderName: undefined,
            nickname: Core__Option.getOr(clickToPayCard.digitalCardData.descriptorName, ""),
            isClickToPayCard: true,
            cardBin: ""
          },
          paymentMethodType: "click_to_pay",
          defaultPaymentMethodSet: false,
          requiresCvv: false,
          lastUsedAt: new Date().toISOString(),
          bank: {
            mask: ""
          },
          recurringEnabled: true,
          billing: defaultDisplayBillingDetails
        };
}

var defaultRedirectionInfo = "ShowRedirectionInfo";

export {
  defaultCardDetails ,
  defaultAddressDetails ,
  defaultDisplayBillingDetails ,
  defaultCustomerMethods ,
  defaultGroupingBehavior ,
  defaultSavedMethodCustomization ,
  defaultLayout ,
  defaultAddress ,
  defaultBillingDetails ,
  defaultBusiness ,
  defaultDefaultValues ,
  defaultshowAddress ,
  defaultNeverShowAddress ,
  defaultBilling ,
  defaultNeverBilling ,
  defaultTerms ,
  defaultFields ,
  defaultStyle ,
  defaultWallets ,
  defaultBillingAddress ,
  defaultSdkHandleConfirmPayment ,
  defaultSdkHandleSavePayment ,
  defaultRedirectionInfo ,
  defaultOptions ,
  getMessageDisplayMode ,
  defaultPaymentMethodMessage ,
  getPaymentMethodMessage ,
  getPaymentMethodTypeConfig ,
  getPaymentMethodConfig ,
  getPaymentMethodsConfig ,
  getPaymentMethodsArrangementForTabs ,
  getCvcIconStyle ,
  getCardBrandIconStyle ,
  getAddress ,
  getBillingDetails ,
  getDefaultValues ,
  getBusiness ,
  getShowType ,
  getApplePayType ,
  getGooglePayType ,
  getSamsungPayType ,
  getPayPalType ,
  getTypeArray ,
  getShowDetails ,
  getShowAddressDetails ,
  getShowTerms ,
  getShowAddress ,
  getDeatils ,
  getBilling ,
  getFields ,
  getGroupingBehaviorFromString ,
  getGroupingBehaviorFromObject ,
  getGroupingBehavior ,
  getMaxItems ,
  getSavedMethodCustomization ,
  getLayoutValues ,
  getTerms ,
  getApplePayHeight ,
  getGooglePayHeight ,
  getSamsungPayHeight ,
  getPaypalHeight ,
  getKlarnaHeight ,
  getTheme ,
  getHeightArray ,
  getStyle ,
  getGooglePayWalletConfig ,
  getPaypalWalletConfig ,
  getGooglePayWalletField ,
  getPaypalWalletField ,
  getApplePayWalletConfig ,
  getApplePayWalletField ,
  getWallets ,
  getRedirectionInfo ,
  getLayout$1 as getLayout,
  getCardDetails ,
  getAddressDetails ,
  getBillingAddressPaymentMethod ,
  getPaymentMethodType ,
  getBank ,
  itemToCustomerObjMapper ,
  createCustomerObjArr ,
  getCustomerMethods ,
  getCustomMethodNames ,
  getBillingAddress ,
  getConfirmParams ,
  getSdkHandleConfirmPaymentProps ,
  getSdkHandleSavePaymentProps ,
  allowedPaymentElementOptions ,
  fieldsToExcludeFromMasking ,
  overrideFieldsToExcludeFromMasking ,
  normalizePath ,
  isPathStartsWithPattern ,
  shouldMaskField ,
  sanitizePaymentElementOptions ,
  sanitizePreloadSdkParms ,
  itemToObjMapper ,
  getIsStoredPaymentMethodHasName ,
  itemToPayerDetailsObjectMapper ,
  convertClickToPayCardToCustomerMethod ,
}
/* Utils-OrcaPaymentPage Not a pure module */
